module.exports = "/images/vendor/flag-icon-css/flags/4x3/as.svg?16f433a627bc83a007bba2cbaa686aee";